import { IInvoice } from '../interfaces';
import { normalizePaymentProvider } from './paymentProvider';

export type ApproveCopy = {
    /** Null keeps the screen's own BankID label. */
    withBankID: string | null;
    withoutBankID: string;
};

/**
 * A Stripe invoice is paid on Stripe's page straight after approving, so the
 * buttons say they lead to payment. How they pay sits on the 30-day option.
 */
export function approveCopy(provider: string | null | undefined): ApproveCopy {
    if (normalizePaymentProvider(provider) === 'stripe') {
        return {
            withBankID: 'approveAndPay',
            withoutBankID: 'approveAndPayWithoutBankID'
        };
    }
    return {
        withBankID: null,
        withoutBankID: 'approveWithoutBankID'
    };
}

/** BankID is already stored and Stripe has not finished, so the customer continues payment. */
export function resumeStripePayment(invoice: IInvoice): boolean {
    return (
        normalizePaymentProvider(invoice.payment_provider) === 'stripe' &&
        invoice.has_bankid_signature === true &&
        invoice.is_signed === false
    );
}
